const INNER = '_kye_field_settings_'

// 默认弹窗配置
export const DIALOG_DEFAULTS = {
  width: '600px',
  title: '个性设置',
  modalAppendToBody: false,
  closeOnClickModal: false,
  closeOnPressEscape: true,
  canResize: false,
  showFullScreenButton: false
}

// 页签数据属性名
export const TAB_PROPS = {
  LABEL: 'label',
  FIELDS: 'fields',
  TYPE: 'type',
  GENERIC_ID: 'genericId',
  AUTH_URL: 'authUrl' // 列权限绑定的请求url
}

export const ORIGIN_FIELDS = 'originFields'

// 左侧面板宽度
export const LEFT_PANEL_WIDTH = '170px'

// 列宽配置
export const COLUMN_WIDTHS = {
  CHECK: '62px',
  FIXED: '50px',
  MOVE: '80px'
}

// 字段数据属性名
export const FIELD_PROPS = {
  KEY: 'key',
  LABEL: 'label',
  SHOW: 'show',
  FIXED: 'fixed',
  CHILD: 'children'
}

export const INNER_FIELD_PROPS = {
  SHOW: `${INNER}show`,
  FIXED: `${INNER}fixed`,
  CHILD: `${INNER}child`,
  INDTERMINATE: `${INNER}indeterminate`
}

// 模板数据属性名
export const TEMPLATE_PROPS = {
  BATCH_ID: 'batchId',
  LABEL: 'templateName',
  FIELDS: 'fieldTemplates'
}

// // 拖拽配置
// export const DRAG_OPTIONS = {
//   animation: 150,
//   ghostClass: 'kye-ghost'
// }

// // 拖拽组名
// export const DRAG_GROUPS = {
//   ROOT: 'root-fields',
//   CHILD: (parentKey) => `field-${parentKey}`
// }

// // 行号格式
// export const ROW_NUMBER = {
//   ROOT: (index) => `${index}.`,
//   CHILD: (index) => `(${index})`
// }

// // 缩进配置
// export const INDENT_CONFIG = {
//   LEVEL_SPACING: 24,
//   BASE_PADDING: 8
// }



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/constants.js